import React from "react";
import Monitor from "../../assets/screen1.png";

const VRLabsSection = () => {
  return (
    <section className="bg-white py-12 sm:py-16 lg:pb-28 lg:pt-24">
      <div className="mx-auto max-w-[1720px] px-4 sm:px-6 md:px-10">
        <div className="flex flex-col items-center gap-8 lg:flex-row lg:items-center lg:gap-12 xl:gap-20">
          <div className="w-full max-w-[870px]">
            <span className="inline-flex bg-[#923D8C] px-3 py-2.5 text-xl font-bold leading-tight tracking-[1%] text-white sm:p-4 sm:text-2xl sm:leading-[26px] md:text-3xl">
              VR Labs
            </span>

            <p className="mt-5 text-justify text-base tracking-[1%] text-black sm:mt-7 sm:text-lg md:mt-9 md:text-xl">
              The VR Labs are immersive, simulation-based science environments
              that allow students to explore complex topics in Physics,
              Chemistry, and Biology through virtual experimentation. Built on
              Unity with high-fidelity 3D models, the labs simulate a real
              science lab where students can conduct safe, repeatable
              experiments without physical risks or expensive lab setups. Each
              VR lab module is curriculum-aligned with international and
              national education boards.
            </p>

            <div className="mt-5 text-base tracking-[1%] text-black sm:mt-6 sm:text-lg md:text-xl">
              <p className="mb-3 sm:mb-4">These labs include</p>
              <ul className="list-disc space-y-2 pl-5 sm:pl-6">
                <li>Interactive visuals</li>
                <li>Drag-and-drop apparatuses</li>
                <li>AI powered personalized learning paths</li>
              </ul>
            </div>

            <p className="mt-4 text-base text-black sm:text-lg md:text-xl">
              Compatible with VR headsets and browsers, the labs provide
              low-cost real-time concept reinforcement with 3D interaction.
            </p>
          </div>

          <div className="relative mx-auto w-full max-w-[640px] shrink-0 xl:max-w-[736px]">
            <div className="aspect-[730/567] w-full border border-black" />
            <img
              src={Monitor}
              alt="VR lab"
              className="absolute left-[4%] top-[4%] z-10 h-[92%] w-[92%] object-cover sm:left-[30px] sm:top-[30px] sm:h-[calc(100%-30px)] sm:w-[calc(100%-30px)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default VRLabsSection;
